import type { SVGProps } from "react";
export interface EggplantIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function EggplantIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: EggplantIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.59 11.342a1.124 1.124 0 0 1 1.95 1.118l-.21.398c-1.082 1.995-2.687 4.021-4.257 5.681-1.652 1.746-3.393 3.22-4.57 3.809a7.45 7.45 0 0 1-7.769-.71C1.97 20.312.875 18.287.875 16.26c0-2.23 1.333-3.882 2.736-5.082 1.373-1.173 3.12-2.148 4.106-2.808 1.914-1.28 3.766-2.985 4.578-3.765l.086-.076a1.126 1.126 0 0 1 1.471 1.7l-.823.77c-1.004.915-2.5 2.196-4.06 3.24-1.226.821-2.65 1.585-3.896 2.649-1.214 1.038-1.948 2.122-1.948 3.372 0 1.233.688 2.624 1.96 3.578a5.2 5.2 0 0 0 5.413.497c.809-.405 2.326-1.636 3.94-3.341 1.59-1.682 3.15-3.693 4.094-5.552l.057-.1Z"
      />
      <path
        fill={color}
        d="M9.835 16.556a1.125 1.125 0 0 1 1.317 1.821l-.349.272c-.224.17-.432.315-.614.427l-.252.142a3.96 3.96 0 0 1-3.865-.216l-.238-.164-.088-.074a1.125 1.125 0 0 1 1.344-1.79l.095.064.205.13c.495.267 1.09.262 1.541.037l.264-.167q.219-.152.546-.415zm1.98-12.741a6.625 6.625 0 0 1 8.504-.727l.178-.177A1.3 1.3 0 0 0 20.875 2a1.125 1.125 0 0 1 2.25 0 3.54 3.54 0 0 1-.802 2.243l-.235.259-.178.177a6.624 6.624 0 0 1-.726 8.505 1.13 1.13 0 0 1-1.098.289c-1.012-.284-1.697-.904-2.083-1.736a4 4 0 0 1-.289-.88 5 5 0 0 1-.589.11c-.702.088-1.7.05-2.421-.672-.723-.723-.757-1.725-.667-2.425a6 6 0 0 1 .122-.638 5 5 0 0 1-.662-.216c-.795-.33-1.652-.964-1.97-2.101-.11-.391 0-.813.288-1.1m7.779 1.59a4.376 4.376 0 0 0-5.464-.582q.1.06.228.114c.418.173.934.237 1.345.237a1.128 1.128 0 0 1 1.006 1.63c-.211.422-.385.925-.44 1.353-.062.475.052.574.026.548-.024-.024.08.09.552.03.428-.053.929-.226 1.35-.436a1.13 1.13 0 0 1 1.095.048c.331.205.533.568.533.958 0 .705.076 1.177.218 1.484a1 1 0 0 0 .085.15 4.374 4.374 0 0 0-.534-5.533Z"
      />
    </svg>
  );
}
